var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg5Flat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 18C0 8.05888 8.05888 0 18 0C27.9411 0 36 8.05888 36 18C36 27.9411 27.9411 36 18 36C8.05888 36 0 27.9411 0 18Z",
    fill: "url(#paint0_linear_1_4597)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4336 18.5664L13.1836 18.0156L14.1094 9.4375H23.3086V11.8281H16.4531L15.9844 16.0117C16.25 15.8555 16.6172 15.7031 17.0859 15.5547C17.5547 15.3984 18.0898 15.3203 18.6914 15.3203C19.4961 15.3203 20.2148 15.4531 20.8477 15.7188C21.4883 15.9766 22.0312 16.3555 22.4766 16.8555C22.9219 17.3477 23.2617 17.9492 23.4961 18.6602C23.7305 19.3633 23.8477 20.1562 23.8477 21.0391C23.8477 21.8281 23.7305 22.5664 23.4961 23.2539C23.2695 23.9414 22.9258 24.5469 22.4648 25.0703C22.0039 25.5938 21.4219 26.0039 20.7188 26.3008C20.0234 26.5898 19.1992 26.7344 18.2461 26.7344C17.5352 26.7344 16.8516 26.6328 16.1953 26.4297C15.5469 26.2188 14.9648 25.9102 14.4492 25.5039C13.9336 25.0898 13.5195 24.582 13.207 23.9805C12.8945 23.3711 12.7148 22.6719 12.668 21.8828H15.4336C15.5039 22.4375 15.6562 22.9102 15.8906 23.3008C16.1328 23.6836 16.4531 23.9766 16.8516 24.1797C17.25 24.3828 17.7109 24.4844 18.2344 24.4844C18.7109 24.4844 19.1211 24.4023 19.4648 24.2383C19.8086 24.0664 20.0938 23.8242 20.3203 23.5117C20.5547 23.1914 20.7266 22.8164 20.8359 22.3867C20.9531 21.957 21.0117 21.4805 21.0117 20.957C21.0117 20.457 20.9453 20 20.8125 19.5859C20.6875 19.1719 20.4961 18.8125 20.2383 18.5078C19.9883 18.2031 19.6719 17.9688 19.2891 17.8047C18.9062 17.6328 18.4648 17.5469 17.9648 17.5469C17.293 17.5469 16.7773 17.6445 16.418 17.8398C16.0664 18.0352 15.7383 18.2773 15.4336 18.5664Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_4597",
    x1: 5.4,
    y1: 5.4,
    x2: 31.2,
    y2: 31.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#40AD72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#B559FD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg5Flat);
export default __webpack_public_path__ + "static/media/5_flat.910e514b7813091eac6a05ccf8746694.svg";
export { ForwardRef as ReactComponent };